import React, { Component } from 'react'
import '../card.css'

class CardContainer extends Component {

    render() {
        return (
            <div className="cards-holder-container">
                {this.props.children}
            </div>
        )
    }
}

export default CardContainer